import React, {useContext} from 'react';
import { AppContext } from '../AppContext';
import {useLocation} from "react-router-dom";

const websiteBaseUrl = process.env.REACT_APP_BASE_URL || '/';

class LinksNavigation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            links: [
                {uri: '/yhteis%C3%B6', name: "Yhteisö"},
                {uri: '/uutiset', name: "Uutiset"},
                //{uri: '/kauppa', name: "PelShop"},
                {uri: '/yhteis%C3%B6edut', name: "Yhteisöedut"},
                {uri: '/bootcamp', name: "Bootcamp"},
                {uri: '/saunatilat', name: "Sauna"},
                {uri: '/turnaukset', name: "Turnaukset"},
            ],
            isMenuOpen: false,
        };

        window.addEventListener("resize", this.onResize.bind(this));

        document.getElementById('MobileMenuOpener').addEventListener('click', (e) => {
            e.preventDefault();
            this.setState({
                isMenuOpen: true,
            });
            e.stopImmediatePropagation();
            e.stopPropagation();
            document.addEventListener('click', this.windowOnClickHandler.bind(this));
        });
        document.getElementById('MobileMenuCloser').addEventListener('click', (e) => {
            e.preventDefault();
            this.setState({
                isMenuOpen: false,
            });
            document.removeEventListener('click', this.windowOnClickHandler.bind(this));
        });
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.onResize.bind(this));
    }

    onResize() {
        this.componentDidUpdate({}, {}, {});
    }

    windowOnClickHandler(e) {
        if (this.state.isMenuOpen === false) {
            // Ignore, menu is hidden!
            return;
        }
        if (e.target.closest('.Links-Navigation') || e.target.closest('.Links-Navigation-Mobile-Menu') || e.target.closest('.Links-Navigation-Mobile-Menu-Close')) {
            // Allow clicks on the mobile menu
            if (e.target.tagName.toLowerCase() === 'a') {
                // ..menu link is clicked -> hide menu!
                document.removeEventListener('click', this.windowOnClickHandler.bind(this));
                this.setState({
                    isMenuOpen: false,
                });
            }
            return;
        }
        e.preventDefault();
        document.removeEventListener('click', this.windowOnClickHandler.bind(this));
        this.setState({
            isMenuOpen: false,
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (window.innerWidth > 767) {
            // Desktop, mobile menu hidden
            document.getElementById('MobileMenuOpener').style.display = 'none';
            document.getElementById('MobileMenuCloser').style.display = 'none';
        } else if (this.state.isMenuOpen) {
            // Mobile menu open
            document.getElementById('MobileMenuOpener').style.display = 'none';
            document.getElementById('MobileMenuCloser').style.display = 'block';
        } else {
            // Mobile, menu closed
            document.getElementById('MobileMenuOpener').style.display = 'block';
            document.getElementById('MobileMenuCloser').style.display = 'none';
        }
        const currentPath = this.props?.location?.pathname;
        if (currentPath) {
            const links = document.querySelectorAll('header .Links-Navigation ul li');
            for (const linkLiParent of links) {
                const link = linkLiParent.querySelector('a');
                if (!link) {
                    continue;
                }
                if (websiteBaseUrl !== '/' && !link.getAttribute('href').includes(websiteBaseUrl)) {
                    link.setAttribute('href', `https://${link.hostname}${websiteBaseUrl}${link.getAttribute('href').replace('/', '')}`);
                }
                const link_href = link.getAttribute('href').replace(`https://${link.hostname}${websiteBaseUrl}`, '/');
                let uri_match = new RegExp(`${link_href}([\/\?\#]|$)`).test(currentPath);
                if (!uri_match) {
                    uri_match = new RegExp(`${encodeURIComponent(link_href).replace(encodeURIComponent('/'), '/')}([\/\?\#]|$)`).test(currentPath);
                }
                if (uri_match) {
                    linkLiParent.classList.add('Active-Link');
                } else if (linkLiParent.classList.contains('Active-Link')) {
                    linkLiParent.classList.remove('Active-Link');
                }
            }
        }
    }

    render() {
        return null;
    }
}

const LinksNavigationWithContext = (props) => {
    const location = useLocation();
    const context = useContext(AppContext);
    return (<LinksNavigation {...props} context={context} location={location} />);
};

export default LinksNavigationWithContext;
